import React, { useState } from 'react';
import { Badge, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppNotificationContent from './AppNotificationContent';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AppTooltip from '../AppTooltip';
import { alpha } from '@mui/material/styles';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const AppNotifications = ({
  drawerPosition,
  tooltipPosition,
  isMenu,
  sxNotificationContentStyle,
  notificationData,
  fetchData,
  markAllRead,
}) => {
  const [showNotification, setShowNotification] = useState(false);
  const { isMobile } = useMobileSettings();
  return (
    <>
      {isMenu ? (
        <Box component='span' onClick={() => setShowNotification(true)}>
          {isMobile ? 'Alerts' : 'Notifications'}
        </Box>
      ) : (
        <AppTooltip title='Notification' placement={tooltipPosition}>
          <IconButton
            className='icon-btn'
            sx={{
              borderRadius: '50%',
              width: 40,
              height: 40,
              color: (theme) => theme.palette.text.secondary,
              backgroundColor: (theme) => theme.palette.background.default,
              border: 1,
              borderColor: 'transparent',
              transition: 'transform 0.3s ease-in-out',
              '&:hover, &:focus': {
                color: (theme) => theme.palette.text.primary,
                backgroundColor: (theme) =>
                  alpha(theme.palette.background.default, 0.9),
                borderColor: (theme) =>
                  alpha(theme.palette.text.secondary, 0.25),
                transform: 'scale(1.1)',
              },
            }}
            onClick={() => setShowNotification(true)}
            size='large'
          >
            <NotificationsNoneIcon />
            <Badge
              badgeContent={notificationData?.length}
              color='error'
              sx={{
                right: -3,
                top: -16,
                transition: 'transform 0.3s ease-in-out', // Add a transition effect for scaling
                transform: 'scale(1)', // Initial scale value
              }}
            ></Badge>
          </IconButton>
        </AppTooltip>
      )}

      <Drawer
        anchor={drawerPosition}
        open={showNotification}
        onClose={() => setShowNotification(false)}
      >
        <AppNotificationContent
          sxStyle={sxNotificationContentStyle}
          onClose={() => setShowNotification(false)}
          notificationData={notificationData}
          fetchdata={fetchData}
          markAllRead={markAllRead}
        />
      </Drawer>
    </>
  );
};

export default AppNotifications;

AppNotifications.defaultProps = {
  drawerPosition: 'right',
  tooltipPosition: 'bottom',
};

AppNotifications.propTypes = {
  drawerPosition: PropTypes.string,
  tooltipPosition: PropTypes.string,
  isMenu: PropTypes.bool,
  sxNotificationContentStyle: PropTypes.object,
  fetchData: PropTypes.func,
  notificationData: PropTypes.object,
  markAllRead: PropTypes.func,
};
